<template>
  <div class="my-breadcrumb" style="box-shadow: rgb(177 194 223) 1px 2px 0px 0px !important;" align-h="center">
    <div class="breadcrumb-title align-items-center d-flex ml-5">
      <!-- <b-link
        :to=" `/app/prod/clientes/${submital.client_id}`"
        :disabled="!submital.client_id"
        class="breadcrumb-link"
      >
        <font-awesome-icon :icon="['far', 'address-book']" size="lg" fixed-width />
        <span v-if="submital.client">{{ submital.client.client_num }}</span>
        <span v-else>CL00000</span>
      </b-link>
      <font-awesome-icon :icon="['far', 'chevron-right']" pull="right"/> -->
      <b-link
        :to="`/app/prod/submitals/${submital.id}`"
        :disabled="!submital.id"
        class="breadcrumb-link"
      >
        <span v-if="submital.submital_no">{{ submital.submital_no }}</span>
        <span v-else>SUB-0</span>
      </b-link>
      <font-awesome-icon :icon="['far', 'chevron-right']" pull="right"/>
      <span class="breadcrumb-inactive">Configurador</span>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'ConfiguratorStepNavBar',
    computed: {
      ...mapState({
        submital: state => state.configurator.submital
      })
    }
  }
</script>